module.exports = __webpack_public_path__ + "img/img1.0b35a738.png";